module.exports = __webpack_public_path__ + "static/media/hhCl.80d66d18.wav";